<template>
	<v-card>
		<v-card-title>
			<h1 class="display-1">Dirección</h1>
		</v-card-title>

			<v-card-text>
				<v-form v-model="validarDireccion">
					<v-text-field
						v-model="codigoPostal"
						label="Código Postal"
						@keypress="buscaCP"
					/>
					<v-text-field 
						v-model="calleyNumero"
						label="Calle y Número"
						:counter="50"
						:rules="direccionRules"
					/>
					<v-text-field
						v-model="entidad"
						label="Entidad"
					/>
					<v-text-field
						v-model="municipio"
						label="Municipio"
					/>
					<v-combobox
						label="Colonia"
						v-model="colonia"
						:items="colonias"
						name="colonia"
						item-text="asentamiento"
						item-value="id"
					>
					</v-combobox>
					<v-btn
						color="info"
						@click="agregaDatos"
					>Registrar dirección</v-btn>
				</v-form>
			</v-card-text>
	</v-card>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi.js'
export default {
	data() {
		return {
			idCodigoPostal: 0,
			codigoPostal: '',
			calleyNumero: '',
			idEntidad: 0,
			entidad: '',
			idMunicipio: 0,
			municipio: '',
			idColonia: 0,
			colonia: '',
			colonias: [],
			respuesta: '',
			direccionRules: [
				value => value.length <= 50 || "No debe exceder de 50 caracteres"
			],
			validarDireccion: false
		}
	},
	methods: {
		buscaCP(e){
			if(e.key == "Enter"){
				ServiciosApi.buscaDireccion(this.codigoPostal)
					.then(response =>{
						this.respuesta = response.data
						if(this.respuesta.estatus === 'ok'){
							this.colonia = ''
							console.log(this.respuesta.datos.colonia)
							this.idCodigoPostal = this.respuesta.datos.idCodigoPostal
							this.idEntidad = this.respuesta.datos.idEntidad
							this.entidad = this.respuesta.datos.entidad
							this.idMunicipio = this.respuesta.datos.idMunicipio
							this.municipio = this.respuesta.datos.municipio
							this.colonias = this.respuesta.datos.colonia
						}
					})
			}
		},
		agregaDatos() {
			let direccion = {
				calleyNumero: this.calleyNumero,
				idCodigoPostal: this.idCodigoPostal,
				idEntidad: this.idEntidad,
				idMunicipio: this.idMunicipio,
				idColonia: this.colonia.id
			}
			this.$emit('agrega-direccion', direccion)
		}
	}
}
</script>

<style>
</style>
